import { Link } from "react-router-dom";
import { NavigateBeforeOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

// import logo from '../../assets/logo.png'
import { useWindowSize } from "../../hooks";
// import Breadcrumbs from "../../views/Breadcrumbs";

const ContainerScreenGeneral = ({ children, titulo, linkBack, size, breadcrumbs }) => {
  const width = useWindowSize();

  return (
    <section
      className={`${size === "lg" ? "col-12 col-md-11 col-lg-10" : size === "full" ? "col-12 col-lg-12" : size === "sm" ? "col-12 col-sm-9 col-md-7 col-lg-6 col-xl-4" : "col-12 col-md-10 col-xl-8"} mx-auto mb-5 pb-5 position-relative`}
    >
      <div className={`${width.width > 450 && "container_menu p-3 rounded"}`} >
        <div className={`${width.width > 450 && "rounded"} bg-white p-2  pb-2 pb-5`}>
          {linkBack && (
            <div>
              <div className="d-flex align-items-center gap-4 justify-content-between">
                <Link
                  className={`btn btn-primary ${width.width < 576 ? "rounded-circle" : ""} btn-sm`}
                  to={linkBack}
                  style={{ padding: width.width < 576 ? "3px" : "3px 10px 3px 0" }}
                >
                  {width.width < 576 ? (
                    <Tooltip title={"Volver"} arrow>
                      <NavigateBeforeOutlined />
                    </Tooltip>
                  ) : (
                    <>
                      <NavigateBeforeOutlined />
                      Volver
                    </>
                  )}
                </Link>
              </div>
              <hr className="m-0 my-3" />
            </div>
          )}
          {titulo && <h3 className="col-12 text-center p-3 py-0 m-0 fs-4">{titulo}</h3>}
          {children}
        </div>
      </div>
    </section>
  );
};

export default ContainerScreenGeneral;
